import { Theme } from "@mui/material/styles";

const styleIconButton = ({ breakpoints }: Theme) => ({
    pr: 1, pl: 1,

    "& .material-icons, .material-icons-round": {
        fontSize: `40px !important`,
    },

    "& .MuiTypography-root": {
        display: "none",

        [breakpoints.up("sm")]: {
            display: "inline-block",
            lineHeight: 1.2,
            ml: 0.5,
        },
    },
});

const styleBoxPopper = (theme: any) => {
    return {
        [theme.breakpoints.down('sm')]: {
            [theme.breakpoints.down(325)]: {
                width: "200px !important",
            },
            [theme.breakpoints.up(325)]: {
                width: "250px !important",
            },
        },
        [theme.breakpoints.up('sm')]: {
            width: "300px !important",
        },
    }
}

export {
    styleBoxPopper,
    styleIconButton,
};
